<template>
    <div class="serchBox cell" :style="{minHeight:minHeight+'px'}">
    <!-- <div class="cell" :style="{height:minHeight+'px'}" @scroll="scrollEvent"> -->
         <div class="cellList" v-for="(item,index) of defList" :key="index" >
             <!-- 左侧缩略图 -->
            <div class="left" @click.stop="jumpDetails(item.file_type,item.id,item.category_id)">
                <div class="leftDiv">
                    <img v-if="item.file_type==0" :src="item.thumbnail" alt="">
                    <img v-else-if="item.file_type==1"  src="@/assets/imgs/pdf.png" alt="">
                    <img v-else-if="item.file_type==2" class="lianjieImg"   src="@/assets/imgs/lianjie.png" alt="">
                    <img v-else :src="item.thumbnail" alt="">
                </div>
                <div v-if="item.file_type==0" >
                    <div v-show="item.photos_cnt!=1" class="photos_cnt">{{item.photos_cnt}} 张</div>
                </div>
                <!-- 视频播放icon -->
                <div v-if="item.file_type==3" class="bofang"  @click.stop="getInfos(item.file_type,item.id,item.category_id)">
                    <img class="bofangImg" src="@/assets/imgs/bofang.png" alt="">
                </div>
            </div>
            <!-- <div class="center"></div> -->
            <!-- 右侧标题 -->
            <div class="right">
                <!-- 上  标题 -->
                <div class="rightTitle" @click.stop="jumpDetails(item.file_type,item.id,item.category_id)">   <!--不加此样式，qq浏览器对不齐-->
                    <div class="title">
                            <p v-if="item.file_type==0 || item.file_type==1"  class="supTitle" v-text='item.post_title'>
                            </p>
                            <p v-else-if="item.file_type==2" class="supTitle" v-text='item.post_title'>
                            </p>
                            <p  v-else class="supTitle" v-text='item.post_title'>
                            </p>
                    </div>
                </div>
                <!-- 下  时间/分享 -->
                <div class="btColor">
                    <div @click.stop="jumpDetails(item.file_type,item.id,item.category_id)">
                        <span>{{item.published_time | timeType}}</span>
                    </div>
                    <!-- 点击弹出弹出层，指示分享 -->
                    <div class="eye">
                        <div>
                            <img class="icon" src="@/assets/imgs/eye.png" alt="">
                            <span>{{item.post_hits}}</span>
                        </div >
                        <div class='colect' @click.stop="toCollect(index,item.is_fav,item.id)">
                            <img class="icon" :src="item.is_fav=='1'?icon1:icon2" alt="">
                        </div>
                        <div v-if="item.file_type!=2" @click.stop="toShare(item)">
                            <img class="icon" src="@/assets/imgs/fx.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="totle"></div>

        <div style="height:75px;"></div>
        <beian class="beian"></beian>
        <!-- <div v-show="isShow" class="noMore">没有更多了</div> -->
        <div  v-if="upShow" class="popup"  @click.stop="popup()">
            <img class="upImg" src="@/assets/imgs/popup.png" alt="">
            <div class="text">
                <p>立即分享给好友吧</p>
                <p>点击屏幕右上角将本页面分享给好友</p>
            </div>
        </div>
    </div>
   
</template>

<script>
import {mapState,mapActions } from 'vuex'
import https from '../../https.js' 　
import { Indicator } from 'mint-ui';
import beian from "./footer"
export default {
  props:["defList","isShow"],
  data () {
    return {
        isCollect:false,
      upShow:false,
      minHeight:"",
      icon1:require('@/assets/imgs/star1.png'),
     icon2:require('@/assets/imgs/star.png'),
    }
  },
  created(){
    var cellHeight=document.documentElement.clientHeight;
    //减去视频高度和tab高度
    this.minHeight=cellHeight-this.$store.state.videoTabHeight;
  },
  computed: {
    ...mapState([
        'pdfDefault',
        'linkDefault',
        'shareDefault'
    ])
  },
  methods:{
      ...mapActions([
      'addCollects',
      'deletCollects',
      'getArticals',
      'setVideoMsg'
    ]),
    async toCollect(cur,fav,curId){
          if(fav=='0'){
              this.shoucangFn(cur,curId)
          }else{
              this.deletShoucang(cur,curId)
          }
      },
      async shoucangFn(cur,curId){
          let info=new Object()
          info.id=curId
          let result=await this.addCollects(info)
          if(result.code=='1'){
              this.$toast(result.msg)
              this.defList[cur].is_fav=1
          }
      },
      async deletShoucang(cur,curId){
          let ids=new Array()
          ids.push(curId)
          let info=new Object()
          info.id=ids
          info.ia_all=0
          const result=await this.deletCollects(info)
          if(result.code=='1'){
              this.$toast(result.msg)
             this.defList[cur].is_fav=0
          }else{
              this.$toast('操作失败，请联系管理员')
          }
      },

      jumpDetails(type,id,cid){
          if(type==0 || type==1){      //图片，pdf
              this.$router.push('/details?type='+type+'&id='+id)
          }else{  
             this.getInfos(type,id,cid)
          }
      },
      async getInfos(type,id,cid){
          let info=new Object()
          info.id=id
          let result=await this.getArticals(info)
          if(result.code=='1'){
              let res=result.data
              if(type=='2'){
                   var URL=res.source_path;
                var reg=/amp;/
                URL=URL.replace(reg,"");
                window.location.href=URL
              }else{
                this.setVideoMsg(res)
                this.$router.push("/list?id="+cid+"&"+"videoId="+id)
              }
             
          }
      },
      popup(){
        this.upShow=!this.upShow
      },
      getURL(ptype,type,id,cid){
        let origin=window.location.origin
        if(type==0 || type==1){
          if(ptype=='URL'){
            return origin+'#/details?type='+type+'&id='+id
          }else{
              return type==0?this.shareDefault:this.pdfDefault 
          }
          
        }else if(type=='2'){
           if(ptype=='URL'){
             return this.getInfosURL(type,id,cid)
           }else{
             return this.linkDefault
           }
          
        }else if(type=='3'){
          if(ptype=='URL'){
            return origin+"#/list?id="+cid+"&"+"videoId="+id
          }else{
            return this.getInfosURL(type,id,cid)
          }
          
        }
      },
      async getInfosURL(type,id,cid){
          let info=new Object()
          info.id=id
          let result=await this.getArticals(info)
          if(result.code=='1'){
            
              let res=result.data
              if(type=='2'){
                  var reg=/amp;/
                  return res.source_path.replace(reg,"")
              }else{
                return res.thumbnail?res.thumbnail:this.shareDefault
              }
             
          }
      },
    async toShare(item){
      this.upShow=true
      let origin=window.location.origin
      let parm=new Object()
      parm.shareTitle=item.post_title
      parm.shareDesc=''
      parm.shareUrl=item?await this.getURL('URL',item.file_type,item.id,item.category_id):''
      parm.shareImg=item.thumbnail?item.thumbnail:await this.getURL('IMG',item.file_type,item.id,item.category_id)
      this.wxShare(parm)
    },
    wxShare(parm){
          let parm2=new Object()
          parm2.shareTitle=parm.shareTitle,
          parm2.shareDesc=parm.shareDesc,
          parm2.shareUrl=parm.shareUrl,
          parm2.shareImg=parm.shareImg,
          this.$wxShare(parm2)
    },
  },
  components:{
    "beian":beian,
  }
}
</script>

<style src="@/assets/search.css" scoped></style>
<style scoped>
    .cell{
        padding:0;
        margin-top:0;
        min-height:100%;
        position:relative;
    }
   
    .beian{
        width:100%;
        position: absolute;
        bottom:0;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/cellList.vue